import UserType from '../const/UserType';

export interface RouteConfig {
  path: string; // 前端路由路径
  component?: string; // 页面文件名称(只能指定Pages文件夹下的文件)
  exact?: boolean; // 是否精确匹配, default: true
  menu?: boolean;
  header?: boolean;
  auth?: UserType | UserType[];
  layout?: string; // 布局文件名称(只能指定src/layouts文件夹下的文件), 需要配合children使用
  children?: RouteConfig[]; // 子路由
  wrappers?: string[]; // 配置路由的高阶组件(只能指定src/layouts/wrappers文件夹下的文件)
}

export default [
  // 电商
  { path: '/', component: 'HomePage' },
  { path: '/loginOnlineMall', component: 'LoginOnlineMall' },
  { path: '/user/changePassword', component: 'ChangePasswordPage' },
  {
    path: '/',
    layout: 'PrimaryLayout',
    children: [
      {
        path: '/commerce/platform',
        wrappers: ['Authenticated'],
        component: 'WorkspaceCommercePlatform',
      },
      // 个人信息页面
      { path: '/user/setting', component: 'UserSettingCenter' },
    ],
  },
] as RouteConfig[];
